import React, { useEffect, useState } from 'react';
import { useEventContext } from '../../../context/EventContext';
import { useLocaleContext } from '../../../context/LocaleContext';
import { eventPollAnswerClick } from '../../../../../api/player';
import UIButton from '../../../../../globalComponents/UIComponents/UIButton';

export default ({ poll, preview, onAnswer, authorizationCheck }) => {
    const { getProperty, get: getLocale } = useLocaleContext();
    const { event } = useEventContext();
    const [selected, setSelected] = useState([]);
    const maxSelected = poll.multiple ? 100 : 1;

    useEffect(() => {
        setSelected([]);
    }, [poll.id]);

    const isSelected = (answer) => -1 !== selected.indexOf(answer.id);
    const toggleSelected = (answer) => {
        let list = selected.slice();
        if (isSelected(answer)) {
            list = list.filter((id) => id !== answer.id);
        } else {
            if (list.length >= maxSelected) {
                list.shift();
            }
            list.push(answer.id);
        }
        setSelected(list);
    };
    const handleSubmit = async () => {
        if (preview) return;
        
        const isAuth = await authorizationCheck(poll);

        if (isAuth) {
            await eventPollAnswerClick(event.eventKey, poll.id, selected, poll.authorizationRequired);
            await onAnswer(poll, selected);
        }
    };

    return (
        <article className={'poll'}>
            {poll.imageUrl && (
                <div className="poll-image-container">
                    <img
                        src={poll.imageUrl}
                        className="poll-image"
                        alt={getProperty(poll, "text")}
                        title={getProperty(poll, "text")}
                    />
                </div>
            )}
            <p className={"poll-text"}>{getProperty(poll, 'text')}</p>
            {Array.isArray(poll?.answer) && poll.answer.map((answer) => (
                <p key={answer.id}>
                    <button
                        className={'poll-answer bordered' + (isSelected(answer) ? ' active' : '')}
                        onClick={() => toggleSelected(answer)}
                    >
                        <div className={'poll-answer-text'}>{getProperty(answer, 'text')}</div>
                    </button>
                </p>
            ))}
            <p>
                <UIButton color="primary" onClick={handleSubmit} disabled={selected.length === 0}>
                    {getLocale('polls.answer')}
                </UIButton>
            </p>
            {maxSelected === 1 && selected.length === 0 && <p>{getLocale('polls.select.one')}</p>}
            {maxSelected > 1 && <p>{getLocale('polls.select.several')}</p>}
        </article>
    );
};
